import React from 'react';
import { connect } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { DateMonth } from './DateFormat';
import 'swiper/swiper-bundle.css';
import { isMobile } from 'react-device-detect';
//new
SwiperCore.use([Pagination, Navigation]);
const CarouselInvoices = (props) => {
  const invoicesList = props.data;
  const displayAccountType = invoicesList.some(invoice => invoice?.accountType === 'Business');
  var enableNavigation = !isMobile && invoicesList.length > 5;

  const reverseDescription = (description) => {
    if (!description) return '';
    return description.split(' + ').reverse().join(' + ');
  };


  return (
    <div className='carousel-invoices-container'>
      <div className='wrapper-swiper-container'>
      {enableNavigation && <div className='arrow-prev'></div>}
      <div className='wrapper-swiper'>
        <Swiper
          slidesPerView={ 'auto' }
          navigation={enableNavigation ? { nextEl: '.arrow-next', prevEl: '.arrow-prev' } : false}
          pagination={false}
          spaceBetween={isMobile ? 28 : 40}
          breakpoints={{
            220: {
              allowTouchMove: true,
            },
            1230:{
              allowTouchMove: false,
            },
          }}
        >
          {invoicesList.map((invoice, index) => {
            const mainAmount = invoice.invoices[0]?.billAmount?.mainAmount?.replace("(-)", "-").replace(' ', '').trim();
            const subAmount = invoice.invoices[0]?.billAmount?.subAmount;
            const formattedAmount = `${mainAmount}.${subAmount}`;
            return (
              <SwiperSlide key={index}>
                <div
                  className='swiper-invoice-box'
                  onClick={() => props.openInvoiceIframe(invoice?.invoices[0]?.billUrl, invoice?.invoices[0]?.invoiceSourceType, invoice?.banPsId, invoice?.invoices[0]?.id)}
                >
                  {displayAccountType && (
                  <div className='account-type-container'>
                    <div className={
                      invoice?.accountType === 'Business' ? 'business' :
                      invoice?.accountType === 'Private' ? 'private' : ''
                    }>
                      {invoice?.accountType === 'Business' ? 'עסקי' : ''}
                    </div>
                  </div>
              )}
                  <div className="description">{reverseDescription(invoice?.invoices[0]?.description)}</div>
                  <div className="billDate">
                    {invoice?.invoices[0]?.billDate ? DateMonth(invoice?.invoices[0]?.billDate) : ''}
                  </div>
                  <div className="price">
                    <span className='text'>{formattedAmount}</span>
                    <span>&#8362;</span>
                    <div className='arrow'></div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      {enableNavigation && <div className='arrow-next'></div>}
      </div>
    </div>
  );
};
const mapDispatchToProps = {};
export default connect(null, mapDispatchToProps)(CarouselInvoices);
